module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipeDeviceOverlay"
  }, [(!_vm.hidden) ? _c('div', {
    staticClass: "iconContainer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.$t('swipeUp')))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c26fcb8!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/SwipeToMinimal.vue
// module id = 156
// module chunks = 0